import { ApplicationConfig , importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter, MY_DATE_FORMATS } from './shared/adapters/custom-date-adapter';

import { routes } from './app.routes';
// import { provideClientHydration } from '@angular/platform-browser';
import { TokenInterceptor } from './interceptor/token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
    //  provideClientHydration() , 
     importProvidersFrom([BrowserAnimationsModule]) , 
  provideHttpClient(
    withFetch(),
    withInterceptorsFromDi(),
  ),
  {provide : HTTP_INTERCEPTORS , useClass : TokenInterceptor , multi : true},
  { provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
 ]
};


